import { appHttp, unwrap } from '@/shared/http'

// The workspace's Google Sheets sharing list (ORP-25238): the only addresses a Sheets export may
// be shared with. `share_with` outside it is refused with 422 `SHEET_SHARE_NOT_ALLOWED`.
export class SheetSharingApi {
  constructor(private readonly app: Pick<typeof appHttp, 'get'> = appHttp) {}

  async allowedEmails(accountId: number, workspaceId: number | string): Promise<unknown> {
    const body = unwrap(
      await this.app.get<{ data?: { allowed_emails?: unknown } }>(
        `/accounts/${accountId}/workspaces/${workspaceId}/sheets-sharing/`,
        { suppressGlobalErrorHandler: true, meta: { suppressGlobalErrorHandler: true } },
      ),
    )
    return body?.data?.allowed_emails
  }
}

export const sheetSharingApi = new SheetSharingApi()
